module.exports = __webpack_public_path__ + "img/mongo.b10b140c.png";